import React from 'react'
import { observer } from 'mobx-react'
import AppearanceForm from './AppearanceForm'
import { channelStore, billingStore } from '../../app/stores'
import { mapValues } from '../../lib'

const Appearance = (props) => {
  return (
    <AppearanceForm
      disabled={channelStore.isArchived}
      fieldValues={channelStore.appearanceSettings}
      hasWhiteLabelAccess={billingStore.hasWhiteLabelAccess}
      onSubmit={(fieldsData, resetForm) => {
        const values = mapValues(fieldsData)
        return channelStore.saveSettings('appearance', values).then(resetForm)
      }}
    />
  )
}

Appearance.displayName = 'Appearance'

export default observer(Appearance)



// WEBPACK FOOTER //
// ./src/channel/appearance/Appearance.js